import { Link } from "react-router-dom";

interface Props {
  title: string;
  subtitle?: string;
  actionLabel?: string;
  actionTo?: string;
  compact?: boolean;
}

export default function SectionHeading({ title, subtitle, actionLabel, actionTo, compact = false }: Props) {
  return (
    <div className={`flex items-end justify-between gap-4 ${compact ? "mb-3" : "mb-5 md:mb-6"}`}>
      <div className="min-w-0">
        <h2 className="font-heading text-xl md:text-[26px] font-bold text-foreground-950 flex items-center gap-2.5">
          <span className="w-1.5 h-5 md:h-6 rounded-full bg-primary-500 inline-block" />
          {title}
        </h2>
        {subtitle && <p className="mt-1.5 ml-4 text-xs md:text-sm text-foreground-600">{subtitle}</p>}
      </div>
      {actionLabel && actionTo && (
        <Link
          to={actionTo}
          className="shrink-0 flex items-center gap-1 text-xs md:text-sm text-foreground-600 hover:text-primary-600 transition-colors cursor-pointer whitespace-nowrap"
        >
          {actionLabel}
          <i className="ri-arrow-right-line" />
        </Link>
      )}
    </div>
  );
}